export interface Timezone {
    identifier: string;
    offset: string;
}
